/**
 * The rollout gate. Mirrors `packages/core/payments/config.ts`.
 *
 * Two conditions, both outside the merchant's control: the running build
 * contains the engine, and the terminal's `branchId` or `accountUUID` is
 * listed here. A terminal on neither list runs the old flow, and a
 * rollout is a code change with a deploy behind it — which is the trade for a
 * merchant not being able to switch engines mid-service.
 *
 * There is no `businessId` on `businessData`; the identifiers it carries are
 * `branchId` (one outlet) and `accountUUID` (a whole account). Both are
 * supported so a rollout can pilot by outlet and then ramp by merchant — the
 * order that matters, because an outlet exercises payment VARIETY and an
 * account adds VOLUME.
 */

export interface V2Allowlist {
  branchIds: readonly string[];
  accountUUIDs: readonly string[];
}

/** Who runs the engine. Adding an entry is a reviewed code change; removing it is the rollback. */
export const ENGINE_ALLOWLIST: V2Allowlist = {
  branchIds: [],
  accountUUIDs: ["6a963a5b-a99a-442b-a944-cd96c7930a11", "a88d6fa6-b3e1-4138-86d8-e5065d67281b"],
};

export function matchesAllowlist(businessData: any, allowlist: V2Allowlist = ENGINE_ALLOWLIST): boolean {
  if (!businessData) return false;
  const branchId = businessData.branchId != null ? String(businessData.branchId) : undefined;
  const accountUUID = businessData.accountUUID != null ? String(businessData.accountUUID) : undefined;
  if (branchId && allowlist.branchIds.includes(branchId)) return true;
  if (accountUUID && allowlist.accountUUIDs.includes(accountUUID)) return true;
  return false;
}
